/**
 * Token's keys
 */
export const StorageToken = {
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
  expires: 'expires',
};
